import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { AddressSearchResponseData } from "../types/address"

const getData = async (ic: string | undefined) => {
  try {
    const { data } = await api.get(`/address/search/${ic}`)
    return data
  } catch ({ response: { data } }) {
    return data
  }
}

export const useAddressSearch = (ic: string | undefined):
  QueryObserverBaseResult<AddressSearchResponseData> => {
  const { data, ...props } = useQuery<AddressSearchResponseData>(
    queryKeys.ADDRESS_SEARCH(ic),
    () => getData(ic),
    { enabled: Boolean(ic && ic.length === 8) }
  )
  return { data, ...props }
}
